import React from 'react'
import DeleteAnuncioBuques from './DeleteAnuncioBuques'
import EdicionAnuncioBuques from './EdicionAnuncioBuques'
import { cancelarAnuncioDeBuque, deleteAnuncioDeBuque, updateAnuncioBuques } from '../../actions/TablaBuquesAnunciadosActions'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

function OperacionesAnunciosBuques (props) {
  const { fecha, fechaPlanDeEmbarque } = props

  const handleDelete = () => {
    if (!fechaPlanDeEmbarque) {
      props.deleteAnuncioDeBuque(fecha)
    } else {
      toast.error('Error al intentar eliminar el  anuncio. Existe un plan de embarque activo, primero debe eliminarlo.')
    }
  }

  const handleCancelar = () => {
    if (!fechaPlanDeEmbarque) {
      props.cancelarAnuncioDeBuque(fecha)
    } else {
      toast.error('Error al intentar cancelar el anuncio. Existe un plan de embarque activo, primero debe eliminarlo.')
    }
  }

  const handleUpdate = async () => {
    const anuncio = await props.updateAnuncioBuques(fecha)
    console.log(anuncio)
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <DeleteAnuncioBuques handleDelete={handleDelete} handleCancelar={handleCancelar} />
        <EdicionAnuncioBuques handleUpdate={handleUpdate} fechaAnuncio={fecha} />
      </div>
    </>
  )
}

const mapActionsToProps = {
  cancelarAnuncioDeBuque,
  deleteAnuncioDeBuque,
  updateAnuncioBuques
}

export default connect(null, mapActionsToProps)(OperacionesAnunciosBuques)
